/**
 * Global-child - assets/js.
 */

/**
 * Vanilla JS.
 */

/**
 * Swiper.
 */

// トップページ
let swiperOptionFade = {
	loop: true,
	effect: 'fade',
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 3000,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
};
let sliderFront = new Swiper( '.swiper-front', swiperOptionFade );

// 関連商品
let swiperOptionSlide = {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 8,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 3000,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	breakpoints: {
		768: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
	},
};
let sliderRelated = new Swiper( '.swiper-related', swiperOptionSlide );

/**
 * Parallax.
 */
const rellax = new Rellax( '.parallax', {
	speed: 8,
	center: false,
	wrapper: null,
	round: true,
	vertical: true,
	horizontal: false,
});

/**
 * Header nav display.
 */
const isDisplay = function() {
	const hPrimary = document.querySelectorAll( '.p-header__primary' );
	for ( let i = 0; i < hPrimary.length; i++ ) {
		hPrimary[i].classList.add( 'is-display' );
	}
};
setTimeout( isDisplay, 800 );

/**
 * Header nav display scroll
 */
const HNDSArea = document.querySelector( '#header' );
const HNDSBTN = document.getElementById( 'fixed-header' );

const HNDSCallback = ( entries ) => {
	if ( entries[0].isIntersecting ) {
		HNDSBTN.style.opacity = '0';
		HNDSBTN.style.pointerEvents = 'none';
		HNDSBTN.classList.remove( 'fixed-on' );
	} else {
		HNDSBTN.style.opacity = '1';
		HNDSBTN.style.pointerEvents = 'auto';
		HNDSBTN.classList.add( 'fixed-on' );
	}
};

const HNDSObserver = new IntersectionObserver( HNDSCallback );
HNDSObserver.observe( HNDSArea );

/**
 * LOAD MORE.
 */
const infScroll = new InfiniteScroll( '.load-more', {
	append: '.load-more-append',
	path: '.next',
	hideNav: '.pagination',
	button: '#more-button',
	scrollThreshold: false,
	status: '.scroller-status',
	history: 'push',
});

const infiniteItem = document.querySelectorAll( '.more-load-append' );

infScroll.on( 'append', function( response, path, items ) {
	for ( let i = 0; i < items.length; i++ ) {
		reloadSrcsetImgs( infiniteItem[i]);
	}
});

function reloadSrcsetImgs( infiniteItem ) {
	let imgs = infiniteItem.querySelectorAll( 'img[srcset]' );
	for ( let i = 0; i < imgs.length; i++ ) {
		let img = imgs[i];
		img.outerHTML = img.outerHTML;
	}
}

/**
 * VIEW MORE.
 */
const voiceViewMore = document.querySelector( '.p-page__voice-view-more' );
if ( voiceViewMore ) {
	document
		.querySelector( '.p-page__voice-view-more' )
		.addEventListener( 'click', ( e ) => {
			const hiddenItems = document.querySelectorAll(
				'.p-page__voice-contents.hidden'
			);

			if ( 0 < hiddenItems.length ) {
				hiddenItems[0].classList.remove( 'hidden' );
			}

			if ( 1 < hiddenItems.length ) {
				hiddenItems[1].classList.remove( 'hidden' );
			}

			if ( 2 < hiddenItems.length ) {
				return;
			}

			e.currentTarget.classList.add( 'hidden' );
		});
}

/**
 * Chart.
 */
if ( document.URL.match( /renal-power/ ) ) {
	let ctxRP01 = document.getElementById( 'rp-chart-01' );
	let ctxRP02 = document.getElementById( 'rp-chart-02' );
	let ctxRP03 = document.getElementById( 'rp-chart-03' );
	let ctxRP04 = document.getElementById( 'rp-chart-04' );
	let chartRP01 = new Chart( ctxRP01, {
		type: 'bar',
		data: {
			labels: [ 'PTH', 'FEPi', ],
			datasets: [
				{
					label: '維持食',
					data: [ 15.3, 38.6, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '維持食+キトサン',
					data: [ 8.3, 27.9, ],
					backgroundColor: 'rgba(253, 116, 108, 0.64)',
					datalabels: {
						color: 'rgba(253, 116, 108, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '慢性腎臓病モデル猫（11/12部分腎摘）におけるキトサンのリン吸着作用',
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 50,
							suggestedMin: 0,
							stepSize: 10,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
	let chartRP02 = new Chart( ctxRP02, {
		type: 'bar',
		data: {
			labels: [ 'BUN(mg/dl)', '[HCO3-](mEq/L)', ],
			datasets: [
				{
					label: '添加前',
					data: [ 75, 18.2, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '添加後',
					data: [ 63, 20.5, ],
					backgroundColor: 'rgba(253, 116, 108, 0.64)',
					datalabels: {
						color: 'rgba(253, 116, 108, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '自然発症した慢性腎臓病犬におけるキトサンの尿毒素吸着作用',
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 100,
							suggestedMin: 0,
							stepSize: 10,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
	let chartRP03 = new Chart( ctxRP03, {
		type: 'bar',
		data: {
			labels: [ 'FGF-23(pg/ml)', 'PTH(pg/ml)', ],
			datasets: [
				{
					label: '投与前',
					data: [ 102, 104, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '投与後',
					data: [ 55, 69, ],
					backgroundColor: 'rgba(253, 116, 108, 0.64)',
					datalabels: {
						color: 'rgba(253, 116, 108, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '血中リン濃度が正常なヒトの慢性腎臓病患者に対するリン吸着剤の投与効果',
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 160,
							suggestedMin: 0,
							stepSize: 20,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
	let chartRP04 = new Chart( ctxRP04, {
		type: 'bar',
		data: {
			labels: [ '正常食塩', '高食塩', '高食塩+Q10', ],
			datasets: [
				{
					label: '尿中Alb(gμ/日)',
					data: [ 30, 2500, 250, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: 'フリーラジカラル濃度(RLU/腎臓g)',
					data: [ 850, 2700, 250, ],
					backgroundColor: 'rgba(118, 184, 82, 0.64)',
					datalabels: {
						color: 'rgba(118, 184, 82, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '慢性腎臓病モデルに高塩食を給与したラットにおける還元型コエンザイムQ10の腎保護作用',
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 3000,
							suggestedMin: 0,
							stepSize: 500,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
}

if ( document.URL.match( /kidney-disease/ ) ) {
	let ctxKD01 = document.getElementById( 'kd-chart-01' );
	let ctxKD02 = document.getElementById( 'kd-chart-02' );
	let ctxKD03 = document.getElementById( 'kd-chart-03' );
	let chartKD01 = new Chart( ctxKD01, {
		type: 'bar',
		data: {
			labels: [ '＜4', '4-7', '7-11', '≧12', ],
			datasets: [
				{
					label: '',
					data: [ 3.9, 7, 25.4, 63.6, ],
					backgroundColor: 'rgba(118, 184, 82, 0.64)',
					datalabels: {
						color: 'rgba(118, 184, 82, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '犬の年齢別慢性腎臓病発生率',
				fontSize: 16,
			},
			legend: {
				display: false,
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 100,
							suggestedMin: 0,
							stepSize: 10,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
	let chartKD02 = new Chart( ctxKD02, {
		type: 'bar',
		data: {
			labels: [ '＜5', '≧5-＜10', '≧10-＜15', '≧15', ],
			datasets: [
				{
					label: '',
					data: [ 37.5, 40.9, 42.1, 80.9, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '猫の年齢別慢性腎臓病発生率',
				fontSize: 16,
			},
			legend: {
				display: false,
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 100,
							suggestedMin: 0,
							stepSize: 10,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
	let chartKD03 = new Chart( ctxKD03, {
		type: 'bar',
		data: {
			labels: [ '30', '40', '50', '60', '70', '80', ],
			datasets: [
				{
					label: '＞50%',
					data: [ 41, 32, 24, 16, 10, 5, ],
					backgroundColor: 'rgba(69, 127, 202, 0.64)',
					datalabels: {
						color: 'rgba(69, 127, 202, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '49-38%',
					data: [ 31, 27, 20, 15, 9, 5, ],
					backgroundColor: 'rgba(253, 116, 108, 0.64)',
					datalabels: {
						color: 'rgba(253, 116, 108, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '37-25%',
					data: [ 21, 15, 12, 9, 7, 4, ],
					backgroundColor: 'rgba(80, 201, 195, 0.64)',
					datalabels: {
						color: 'rgba(80, 201, 195, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
				{
					label: '後期24-13%',
					data: [ 14, 10, 7, 6, 4, 3, ],
					backgroundColor: 'rgba(118, 184, 82, 0.64)',
					datalabels: {
						color: 'rgba(118, 184, 82, 0.64)',
						anchor: 'end',
						align: 'end',
						padding: {
							top: 4,
						},
					},
				},
			],
		},
		options: {
			title: {
				display: true,
				text: '腎機能による年代別予測寿命',
				fontSize: 16,
			},
			scales: {
				yAxes: [
					{
						ticks: {
							suggestedMax: 50,
							suggestedMin: 0,
							stepSize: 5,
						},
						scaleLabel: {
							display: true,
							labelString: '残存寿命（年）',
							fontSize: 14,
						},
					},
				],
				xAxes: [
					{
						scaleLabel: {
							display: true,
							labelString: '年代',
							fontSize: 14,
						},
					},
				],
			},
			plugins: {
				datalabels: {
					font: {
						size: 14,
					},
				},
			},
		},
	});
}

/**
 * Wave.
 */
const waveArea = document.querySelector( '#header' );
const waveContent = document.getElementById( 'wave' );

const waveCallback = ( entries ) => {
	if ( entries[0].isIntersecting ) {
		waveContent.style.opacity = '0';
		waveContent.style.pointerEvents = 'none';
		waveContent.classList.add( 'display-off' );
	} else {
		waveContent.style.opacity = '1';
		waveContent.style.pointerEvents = 'auto';
		waveContent.classList.add( 'display-on' );
	}
};

const waveObserver = new IntersectionObserver( waveCallback );
waveObserver.observe( waveArea );

( function() {
	let unit = 100,
		canvas,
		context,
		height,
		width,
		xAxis,
		yAxis;

	/**
	 * Init function.
	 *
	 * Initialize variables and begin the animation.
	 */
	function init() {
		canvas = document.getElementById( 'wave-canvas' );

		//Canvasのwidthをウィンドウの幅に合わせる
		//Canvasのheightとwidthはcssで
		//canvas.width = document.documentElement.clientWidth;
		//canvas.height = 40;

		context = canvas.getContext( '2d' );

		height = canvas.height;
		width = canvas.width;

		xAxis = Math.floor( height / 2 );
		yAxis = 0;

		drawAnimation();
	}

	/**
	 * Draw animation function.
	 *
	 * This function draws one frame of the animation, waits 20ms, and then calls
	 * itself again.
	 */
	function drawAnimation() {

		// キャンバスの描画をクリア
		context.clearRect( 0, 0, width, height );

		//波を描画
		drawWave( 'rgba( 255, 255, 255, 0.96 )', 1, 3, 0 );

		// Update the time and draw again
		drawAnimation.seconds = drawAnimation.seconds + 0.004; //スピードを調整
		drawAnimation.t = drawAnimation.seconds * Math.PI;
		setTimeout( drawAnimation, 32 );
	}
	drawAnimation.seconds = 0;
	drawAnimation.t = 0;

	/**
	 * 波を描画
	 * drawWave(色, 不透明度, 波の幅のzoom, 波の開始位置の遅れ)
	 */
	function drawWave( color, alpha, zoom, delay ) {
		context.fillStyle = color;
		context.globalAlpha = alpha;

		context.beginPath(); //パスの開始
		drawSine( drawAnimation.t / 0.5, zoom, delay );
		context.lineTo( width + 10, height ); //パスをCanvasの右下へ
		context.lineTo( 0, height ); //パスをCanvasの左下へ
		context.closePath(); //パスを閉じる
		context.fill(); //塗りつぶす
	}

	/**
	 * Function to draw sine
	 *
	 * The sine curve is drawn in 10px segments starting at the origin.
	 * drawSine(時間, 波の幅のzoom, 波の開始位置の遅れ)
	 */
	function drawSine( t, zoom, delay ) {

		// Set the initial x and y, starting at 0,0 and translating to the origin on
		// the canvas.
		let x = t; //時間を横の位置とする
		let y = Math.sin( x ) / zoom;
		context.moveTo( yAxis, unit * y + xAxis ); //スタート位置にパスを置く

		// Loop to draw segments (横幅の分、波を描画)
		for ( i = yAxis; i <= width + 10; i += 10 ) {
			x = t + ( -yAxis + i ) / unit / zoom;
			y = Math.sin( x - delay ) / 8; //波の高さを調整
			context.lineTo( i, unit * y + xAxis );
		}
	}

	init();
}() );

/**
 * woocommerce_checkout_fieldsの<form>にyubinbango用のクラスを付ける
 */
const form = document.querySelectorAll( 'form.woocommerce-checkout' );
const postCode = document.querySelectorAll(
	'#billing_postcode_field .input-text'
);
const state = document.querySelectorAll( '#billing_state_field .state_select' );
const city = document.querySelectorAll( '#billing_city_field .input-text' );
const address01 = document.querySelectorAll(
	'#billing_address_1_field .input-text'
);
const address02 = document.querySelectorAll(
	'#billing_address_2_field .input-text'
);
for ( let i = 0; i < form.length; i++ ) {
	form[i].setAttribute( 'class', 'checkout woocommerce-checkout h-adr' );
}
for ( let i = 0; i < postCode.length; i++ ) {
	postCode[i].setAttribute( 'class', 'input-text p-postal-code' );
}
for ( let i = 0; i < state.length; i++ ) {
	state[i].setAttribute(
		'class',
		'state_select select2-hidden-accessible p-region'
	);
}
for ( let i = 0; i < city.length; i++ ) {
	city[i].setAttribute( 'class', 'input-text p-locality' );
}
for ( let i = 0; i < address01.length; i++ ) {
	address01[i].setAttribute( 'class', 'input-text p-street-address' );
}
for ( let i = 0; i < address02.length; i++ ) {
	address02[i].setAttribute( 'class', 'input-text p-extended-address' );
}

/**
 * jQuery.
 */
jQuery( document ).ready( function( $ ) {

});
